import { render, staticRenderFns } from "./setting-online-leave-msg.vue?vue&type=template&id=4fe2f82c&"
import script from "./setting-online-leave-msg.vue?vue&type=script&lang=js&"
export * from "./setting-online-leave-msg.vue?vue&type=script&lang=js&"
import style0 from "./setting-online-leave-msg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports